import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useMasters() {
  const q = useQuery({ queryKey: ["masters"], queryFn: async () => (await api.get("/master/all")).data, staleTime: 30_000 });
  const m = q.data || { plants: [], sections: [], lines: [], shifts: [], projects: [], customers: [], assets: [], models: [], jigs_fixtures: [], tools: [], downtime_categories: [], defect_reasons: [], recipients: [], suppliers: [] };
  return { ...q, masters: m };
}
